import { render, staticRenderFns } from "./AuthorityLetter.vue?vue&type=template&id=ac865b1a&scoped=true"
import script from "./AuthorityLetter.vue?vue&type=script&lang=js"
export * from "./AuthorityLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac865b1a",
  null
  
)

export default component.exports